window.bootstrap = require('./bootstrap');
window.cookie = require('js-cookie');
var _ = require('lodash');

// navi action
var gnavi = document.getElementById('nav-global');
var headerH = 250; // headerの高さ
let startPos = 0; // 開始位置
 
var naviFunc = function() {
    let currentPos = document.documentElement.scrollTop;
    if (currentPos > startPos && currentPos > headerH) { // 下スクロールしているとき
        gnavi.classList.add('is-scrolled');
    } else { // 上スクロールしているとき
        if (currentPos < headerH) {
            gnavi.classList.remove('is-scrolled');
        }
    }
    startPos = currentPos;
}
 
window.addEventListener('scroll', _.throttle(naviFunc, 350)); // 0.35秒ごとに呼ばれる

var elm = document.getElementById('cookie-apply-box');
if (elm) {
    if (window.cookie.get('cookie-apply') === undefined) {
        document.body.classList.add('invalid-cookie-apply');
        var cbtn = elm.querySelector('button');
        if (cbtn) {
            cbtn.addEventListener('click', function(e) {
                console.log('click');
                window.cookie.set('cookie-apply', 'true', { expires: 30 })
                document.body.classList.remove('is-cookie-apply');
                document.body.classList.add('is-cookie-apply');
                elm.remove();
            });
        }
    } else {
        document.body.classList.add('is-cookie-apply');
    }        
}
